import { localeSchema } from "../schemas";

export const DEFAULT_LOCALE = localeSchema.enum.en;

export const LOCAL_STORAGE_KEY = "i18nextLocale";
